'use strict';

exports.__esModule = true;
exports.types = exports.errors = exports.parseMediaSrc = exports.createMediaSrc = exports.isValidMediaSrc = undefined;

var _extraMatchersByType;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _mediaItemUtils = require('./../mediaItemUtils/mediaItemUtils');

var mediaItemUtils = _interopRequireWildcard(_mediaItemUtils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var errors = mediaItemUtils.errors;
var types = mediaItemUtils.types;

var matchers = {
  externalUrl: /(^https?)|(^data)|(^blob)|(^\/\/)/,
  inlineSvg: /<svg[\s\S]*>[\s\S]*<\/svg>/im
};

var extraMatchersByType = (_extraMatchersByType = {}, _extraMatchersByType[mediaItemUtils.types.VECTOR] = [matchers.externalUrl, matchers.inlineSvg], _extraMatchersByType[mediaItemUtils.types.IMAGE] = [matchers.externalUrl], _extraMatchersByType[mediaItemUtils.types.DOCUMENT] = [], _extraMatchersByType[mediaItemUtils.types.VIDEO] = [], _extraMatchersByType);

/**
 * @public
 * Create a MediaItem in the form of 'wix:<media_type>:<uri>/...' or extra supported source(e.g., external url) of one of the supported type
 * @param {string} mediaId required for all types
 * @param {MediaType} type required, one of the supported types
 * @param {string} [title] optional for all types
 * @param {number} [width] required for video and image
 * @param {number} [height] required for video and image
 * @param {string} [posterId] required for video
 * @param {string} [watermark] optional for image
 * @returns {{item: string}|{error: string}}
 */
function createMediaSrc(_ref) {
  var mediaId = _ref.mediaId,
      type = _ref.type,
      title = _ref.title,
      width = _ref.width,
      height = _ref.height,
      posterId = _ref.posterId,
      watermark = _ref.watermark;

  var extraMatchers = extraMatchersByType[type];
  if (_lodash2.default.some(extraMatchers, function (matcher) {
    return matcher.test(mediaId);
  })) {
    return { item: mediaId };
  }

  return mediaItemUtils.createMediaItemUri({ mediaId: mediaId, type: type, title: title, width: width, height: height, posterId: posterId, watermark: watermark });
}

/**
 * @public
 * Parse a media item url of one of the supported types, including extra source type(e.g. external url)
 * @param {string} mediaItemSrc
 * @param {string} type
 * @returns {{}|{error: string}}
 */
function parseMediaSrc(mediaItemSrc, type) {
  if (!_lodash2.default.includes(types, type)) {
    return { error: errors.unknown_media_type };
  }

  var extraMatchers = extraMatchersByType[type];
  if (_lodash2.default.some(extraMatchers, function (matcher) {
    return matcher.test(mediaItemSrc);
  })) {
    return { type: type, mediaId: mediaItemSrc };
  }

  var mediaItemUri = mediaItemUtils.parseMediaItemUri(mediaItemSrc);

  if (mediaItemUri.error === errors.non_string_media_id) {
    return mediaItemUri;
  }

  if (mediaItemUri.error === errors.unknown_media_type || type !== mediaItemUri.type) {
    return { error: errors.bad_media_id };
  }

  return mediaItemUri;
}

/**
 * @public
 * Checks if a given url is a valid media source url
 * @param {string} mediaSrc
 * @param {string} type
 * @returns {boolean}
 */
function isValidMediaSrc(mediaSrc, type) {
  var isValidMediaItemUri = mediaItemUtils.isValidMediaItemUri(mediaSrc, type);
  if (isValidMediaItemUri) {
    return true;
  }
  var matchers = extraMatchersByType[type];
  return _lodash2.default.some(matchers, function (matcher) {
    return matcher.test(mediaSrc);
  });
}

exports.isValidMediaSrc = isValidMediaSrc;
exports.createMediaSrc = createMediaSrc;
exports.parseMediaSrc = parseMediaSrc;
exports.errors = errors;
exports.types = types;
//# sourceMappingURL=mediaSrcHandler.js.map